import { memo } from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { useTranslate } from '../../../../../hooks/language/use-translate'

interface Props {
  handleBack: () => void
}

export const ModalDescription = memo(({ handleBack }: Props) => {
  const { translate } = useTranslate()

  return (
    <div className="w-screen h-screen flex flex-col z-50">
      <div className="bg-white h-full rounded-t-3xl py-5 flex flex-col overflow-y-auto">
        <div className="flex justify-center gap-8 mb-4 relative border-b border-b-gray-200">
          <FaArrowLeft
            className="absolute top-1 left-4 text-gray-400"
            onClick={handleBack}
          />
          <span className="pb-2 font-semibold text-gray-500">
            {translate('modal-description-rule')}
          </span>
        </div>

        <div className="px-4">
          <span>
            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Pariatur
            officia doloribus recusandae. Dolorem magni, voluptatibus nihil
            nulla dolor voluptates hic quaerat reprehenderit error est dolore
            optio quos doloremque ipsam totam.
          </span>
        </div>
      </div>
    </div>
  )
})

ModalDescription.displayName = 'ModalDescription'
